/**
 * @generated SignedSource<<9928f591864877c273141de92ddaa1a4>>
 * @relayHash 3b8737cdba63e71ae2d8fab24a11ce0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d009907cb1c5004323b0c4dbcd71ab2ffde3ac679fb5d8a5b290eb6a6342cca1

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraFieldSetPreferencesMutationInput = {
  nodes?: ReadonlyArray<JiraUpdateFieldSetPreferencesInput> | null | undefined;
};
export type JiraUpdateFieldSetPreferencesInput = {
  fieldSetId: string;
  isFrozen?: boolean | null | undefined;
  width?: number | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type useColumnResize_updateIssueViewFieldSetPreferencesMutation$variables = {
  cloudId: string;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  input: JiraFieldSetPreferencesMutationInput;
  namespace?: string | null | undefined;
};
export type useColumnResize_updateIssueViewFieldSetPreferencesMutation$data = {
  readonly jira: {
    readonly updateUserFieldSetPreferences: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnResize_updateIssueViewFieldSetPreferencesMutation = {
  response: useColumnResize_updateIssueViewFieldSetPreferencesMutation$data;
  variables: useColumnResize_updateIssueViewFieldSetPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v4 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
          },
          {
            "kind": "Variable",
            "name": "fieldSetPreferencesInput",
            "variableName": "input"
          },
          {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
          }
        ],
        "concreteType": "JiraFieldSetPreferencesUpdatePayload",
        "kind": "LinkedField",
        "name": "updateUserFieldSetPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "d009907cb1c5004323b0c4dbcd71ab2ffde3ac679fb5d8a5b290eb6a6342cca1",
    "metadata": {},
    "name": "useColumnResize_updateIssueViewFieldSetPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8becd8b07d916c92d44530797f55182f";

export default node;
